// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__24zjj","header":"Messages_header__N3bbt"};